export function checkToChange() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            ctrl.$validators.checkToChange = (modelValue = '') => {

                if (scope.$ctrl.model.isExists && scope.$ctrl.model.subscriptions.length && scope.$ctrl.model.oldTo < modelValue) {

                    return false;

                } else {

                    return true;

                }
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/check-to-change.directive.js